import DeleteDialogModule from './delete.module'

export default DeleteDialogModule
